export default "__VITE_ASSET__BYLko0hs__"